import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect } from 'react';
import Cookies from 'js-cookie';
import pathOr from 'ramda/src/pathOr';
import { getCast, getErrorFromResponse } from '../utils';
import { Auth, setCast } from '../api';
export var useInitCast = function useInitCast(options) {
  var stage = options.stage,
      cookiesDomain = options.cookiesDomain,
      withoutCast = options.withoutCast,
      isTemporaryProfile = options.isTemporaryProfile,
      ssdcpName = options.ssdcpName,
      ssdtiName = options.ssdtiName,
      ssdtpName = options.ssdtpName,
      onCastSuccess = options.onCastSuccess,
      onLoginError = options.onLoginError,
      onLoginTemporary = options.onLoginTemporary;
  useEffect(function () {
    if (!withoutCast && !(!!window.MSInputMethodContext && document.documentMode)) {
      getCast(Auth.sign, stage).then(function (jwt) {
        setCast(jwt);
        onCastSuccess(jwt);
        var ssdcp = Cookies.get(ssdcpName);

        if (isTemporaryProfile && (!ssdcp || (ssdcp === null || ssdcp === void 0 ? void 0 : ssdcp.length) === 32)) {
          var ssdtp = Cookies.get(ssdtpName);
          var ssdti = Cookies.get(ssdtiName);

          if (ssdtp && ssdti) {
            onLoginTemporary({
              resourceId: ssdti,
              token: ssdtp
            });

            if (window && window.dataLayer) {
              window.dataLayer.push({
                auth: '1',
                b2bCompanyId: undefined,
                ffpMember: undefined,
                userId: ssdti
              });
            }
          } else {
            Auth.createProfile({
              profile: {
                type: 'TEMPORARY_WEB'
              }
            }).then(function (res) {
              var token = pathOr(null, ['data', 'profile', 'token'], res);
              var resourceId = pathOr(null, ['data', 'profile', 'id'], res); // TODO: PS-5475
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore

              Cookies.set(ssdtpName, token, _objectSpread(_objectSpread({}, cookiesDomain ? {
                domain: cookiesDomain
              } : {}), {}, {
                expires: 3650,
                path: '/'
              })); // TODO: PS-5475
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore

              Cookies.set(ssdtiName, resourceId, _objectSpread(_objectSpread({}, cookiesDomain ? {
                domain: cookiesDomain
              } : {}), {}, {
                expires: 3650,
                path: '/'
              }));
              onLoginTemporary({
                resourceId: resourceId,
                token: token
              });

              if (window && window.dataLayer) {
                window.dataLayer.push({
                  auth: '1',
                  b2bCompanyId: undefined,
                  ffpMember: undefined,
                  // TODO: PS-5475
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  userId: resourceId
                });
              }
            }).catch(function (res) {
              var errorObj = getErrorFromResponse(res);
              onLoginError(errorObj);
            });
          }
        }
      });
    }
  }, []);
};